import { render, staticRenderFns } from "./ExpensesViewMobile.vue?vue&type=template&id=cc8c5b20&scoped=true&"
import script from "./ExpensesViewMobile.vue?vue&type=script&lang=js&"
export * from "./ExpensesViewMobile.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesViewMobile.vue?vue&type=style&index=0&id=cc8c5b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8c5b20",
  null
  
)

export default component.exports